module.exports = __webpack_public_path__ + "img/bg_new-setup.60a3181d.jpg";